import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import * as style from './PageDescription.css';

export const PageDescription: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return (
    <div className={style['container']}>
      <UIText2 as="p" color="current_color">
        {children}
      </UIText2>
    </div>
  );
};
